import React, { useState } from "react";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { getRoomUsersList } from "../../../services/OrganisationServices/hostelRoomServices";

const RoomUsersTable = ({hostelId, roomId}) => {
  return (
    <MasterTable
      getTableData= {getRoomUsersList}
      tab1={"Hostel"}
      hostelId={hostelId}
      roomId={roomId}
      tab2={"Room Users"}
      externalPermis= { {
        POST: 0,
        GET: 1,
        PUT: 0,
        DELETE: 0,
        PATCH: 0,
      }}
          //   deleteRow={deleteHostel}
    />
 
  );
};

export default RoomUsersTable;
